// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d6qb","colBig":"styles_colBig__nYf3_","colSmall":"styles_colSmall__jhu4Z"};